export const shouldShowCartEmptyState = (
  isPanelContext: boolean,
  isCartEmpty: boolean,
  didCartBecomeEmpty: boolean,
  isCartBusy: boolean
) => isCartEmpty && (!isPanelContext || (didCartBecomeEmpty && !isCartBusy));
